"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const Arrow = ({ active, direction }) => {
    const arrowSize = 15;
    const fillColor = active ? '#0050d8' : '#000000';
    return ((0, jsx_runtime_1.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", width: arrowSize, height: arrowSize, viewBox: "0 0 18 18", children: [active && direction === 'desc' ? ((0, jsx_runtime_1.jsx)("path", { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z", fill: fillColor })) : ((0, jsx_runtime_1.jsx)("path", { d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z", fill: fillColor })), (0, jsx_runtime_1.jsx)("path", { d: "M0 0h24v24H0z", fill: "none" })] }));
};
function TableHeaderCell({ currentSort, displayName, defaultDirection = 'asc', isLast, isActive, title, updateSort }) {
    const nextSort = currentSort.direction === 'asc' ? 'desc' : 'asc';
    const nextSortFull = nextSort === 'asc' ? 'ascending' : 'descending';
    const [hover, setHover] = (0, react_1.useState)(false);
    function clickedSort(e) {
        e.stopPropagation();
        if (!updateSort)
            return;
        if (isActive) {
            // toggle the sort direction
            updateSort(title, nextSort);
        }
        else {
            updateSort(title, defaultDirection);
        }
    }
    // keyboard accessible option
    function pressedKey(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            clickedSort(e);
        }
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('bah-uswds-table-header-cell-inner', isLast && 'last-column'), children: (0, jsx_runtime_1.jsx)("div", { onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), "aria-label": displayName, className: "bah-uswds-table-header-cell-content", onClick: clickedSort, onKeyDown: pressedKey, role: "presentation", 
            // allow keyboard selection of the header cell
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex: 0, children: (0, jsx_runtime_1.jsxs)("div", { className: "bah-uswds-table-header-sort", children: [(0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-table-header-label", children: (0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", children: displayName }) }), (0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-table-header-sort-icon", children: (0, jsx_runtime_1.jsx)("button", { type: "button", "aria-label": `Sort table by ${nextSortFull} ${displayName}`, onClick: clickedSort, title: `Sort table by ${nextSortFull} ${displayName}`, children: (hover || isActive) && ((0, jsx_runtime_1.jsx)(Arrow, { active: isActive, direction: currentSort?.direction })) }) })] }) }) }));
}
exports.default = TableHeaderCell;
